import { render, staticRenderFns } from "./SanteTns.vue?vue&type=template&id=9868b8f4&"
import script from "./SanteTns.vue?vue&type=script&lang=js&"
export * from "./SanteTns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports